import { Paper, Typography } from '@mui/material';
import type { FunctionComponent } from 'react';

export const StagingBanner: FunctionComponent = () => (
    <Paper
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: (theme) => theme.palette.warning.dark,
            color: '#fff',
            position: 'fixed',
            top: 0,
            zIndex: 2000,
            left: 0,
            height: 22,
            px: 1,
            borderRadius: 1,
        }}
    >
        <Typography
            variant='caption'
            sx={{
                fontWeight: 'bold',
                color: '#fff',
                fontSize: '0.7rem',
            }}
        >
            Staging!
        </Typography>
    </Paper>
);
